import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BookOpenCheck, Layers3, LogOut, MessageSquareHeart } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { ServiceCard } from "@/components/padma/ServiceCard";
import { ServiceNotice } from "@/components/padma/ServiceNotice";
import "@/pages/PadmaHub.css";

const SERVICES = [
  {
    id: "kios",
    title: "KIOS",
    actionLabel: "KIOS - KIPK Operation Desk",
    description: "KIPK Operation Desk",
    status: "Layanan aktif",
    tone: "active",
    icon: Layers3,
  },
  {
    id: "laksmi",
    title: "LAKSMI",
    actionLabel: "LAKSMI - Layanan Konsultasi Kemahasiswaan",
    description: "Layanan Konsultasi Kemahasiswaan Perguruan Tinggi",
    status: "Akses eksternal",
    tone: "external",
    icon: MessageSquareHeart,
  },
  {
    id: "mantab",
    title: "MANTAB",
    actionLabel: "MANTAB - Manajemen Buku Tabungan",
    description: "Manajemen Buku Tabungan bagi Mahasiswa KIPK Baru",
    status: "Layanan aktif",
    tone: "active",
    icon: BookOpenCheck,
  },
];

const ROLE_LABELS = { master: "Super Admin", admin: "Admin", pt: "Perguruan Tinggi" };
const KIOS_DESTINATIONS = { master: "/kipk", admin: "/kipk/manajemen-akun", pt: "/pt" };

export default function PadmaHub() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [notice, setNotice] = useState(null);

  const selectService = (serviceId) => {
    if (serviceId === "kios") {
      navigate(KIOS_DESTINATIONS[user?.role] || "/padma");
      return;
    }
    if (serviceId === "mantab") {
      navigate("/mantab");
      return;
    }
    if (serviceId === "laksmi") {
      navigate("/laksmi");
      return;
    }
    setNotice(serviceId);
  };

  const signOut = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="padma-hub" data-testid="padma-hub-page">
      <header className="padma-hub-header">
        <div className="padma-hub-nav">
          <div className="padma-hub-brand">
            <Link to="/padma" className="padma-hub-brand-link" aria-label="Buka Akses Layanan PADMA" title="Akses Layanan PADMA" data-testid="padma-hub-home-link"><img src="/logo-padma-transparent.png" alt="Logo PADMA" data-testid="padma-hub-logo" /></Link>
            <div><strong>PADMA</strong><span>LLDIKTI Wilayah VII</span></div>
          </div>
          <div className="padma-hub-account">
            <div className="padma-hub-user">
              <strong data-testid="padma-user-name">{user?.display_name || user?.username || "Pengguna PADMA"}</strong>
              <span data-testid="padma-user-role">{ROLE_LABELS[user?.role] || user?.role}</span>
            </div>
            <button type="button" className="padma-logout" onClick={signOut} data-testid="padma-logout-button">
              <LogOut size={16} /><span>Keluar</span>
            </button>
          </div>
        </div>
      </header>

      <main className="padma-hub-main">
        <section className="padma-hub-intro" aria-labelledby="padma-hub-title">
          <div className="padma-hub-eyebrow">SILAHKAN PILIH</div>
          <h1 id="padma-hub-title" data-testid="padma-hub-title">AKSES LAYANAN</h1>
          <p data-testid="padma-hub-description">Panel Layanan Administasi Kemahasiswaan LLDIKTI Wilayah VII.</p>
        </section>

        <section className="padma-services" aria-label="Daftar layanan PADMA">
          {SERVICES.map((service, index) => (
            <ServiceCard key={service.id} service={service} index={index} onSelect={selectService} />
          ))}
        </section>
      </main>

      <footer className="padma-hub-footer">
        <span>Tim Kerja Kemahasiswaan</span><strong>LLDIKTI Wilayah VII</strong>
      </footer>
      <ServiceNotice serviceId={notice} onClose={() => setNotice(null)} />
    </div>
  );
}